<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="hosts"
        :search="search"
        :items-per-page="15"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="name"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  ><v-icon class="mr-2">mdi-plus-thick</v-icon
                  >{{ $t("button.newItem") }}</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form">
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="editedItem.hostname"
                            :label="$t('table.hostname')"
                            :rules="rules.fieldRequired"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                                  v-model="editedItem.ip"
                                  :label="$t('table.ip')"
                                  :rules="rules.ipRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                                  v-model="editedItem.mac"
                                  :label="$t('table.mac')"
                                  :rules="rules.macRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-checkbox
                            v-model="editedItem.wakeable"
                            :label="$t('table.wakeable')"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="close">{{ $t("button.cancel") }}</v-btn>
                  <v-btn color="primary" @click="save">{{
                    $t("button.save")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" color="primary" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
export default {
  mixins: [validationRules],
  data() {
    return {
      dialog: false,
      search: this.$route.hash.replace("#",""),
      hosts: [],
      editedIndex: -1,
      editedItem: {
        hostname: "",
        ip: "",
        mac: "",
        wakeable: true
      },
      defaultItem: {
        hostname: "",
        ip: "",
        mac: "",
        wakeable: true
      }
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("title.newItem")
        : this.$t("title.editItem");
    },
    headers() {
      return [
        {
          text: this.$t("table.hostname"),
          value: "hostname"
        },
        {
          text: this.$t("table.ip"),
          value: "ip"
        },
        {
          text: this.$t("table.mac"),
          value: "mac"
        },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/host";
      axios
        .get(path)
        .then(response => {
          this.hosts = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.hosts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.id = item.id;
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm(this.$t("message.confirm.delete"))) {
        let path = this.$store.state.endpoint + "/host/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.hosts.indexOf(item);
            this.hosts.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("message.correct.deleteItem")
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        const index = this.editedIndex;
        const data = this.editedItem;
        if (index > -1) {
          path = this.$store.state.endpoint + "/host/" + this.editedItem.id;
          axios
            .patch(path, this.editedItem)
            .then(response => {
              Object.assign(this.hosts[index], data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/host";
          const data = this.editedItem;
          axios
            .post(path, data)
            .then(response => {
              data.id = response.data.id;
              this.hosts.push(data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
        this.close();
      }
    }
  }
};
</script>
